import React, { Component } from 'react';
import { Button, DialogContainer, Switch, TextField, Toolbar } from 'react-md';
import { Usuario } from '../models/Usuario';
import { formatCpf } from '../common/formaters';
 
class UsuarioForm extends Component {
    
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        const { visible, model, pageX, pageY } = this.props;

        return (
            <DialogContainer id="modal-form" visible={visible} pageX={pageX} pageY={pageY}
                fullPage onHide={this.hide} aria-labelledby="modal-form-title">
                <form onSubmit={this.handleSave}>
                    <Toolbar fixed colored title="Usuario" titleId="modal-form-title" 
                        nav={<Button icon onClick={this.hide}>close</Button>}
                        actions={<Button type="submit" raised className="btn btn-primary" iconChildren="check">Salvar</Button>}/>
                    <section className="md-toolbar-relative">
                        <div className="md-cell--center md-cell--6">
                            <TextField id="form-usuario-nome" label="Nome" lineDirection="center" required
                                className="md-cell md-cell--bottom md-cell--12" placeholder="Digite o nome do usuário" 
                                onChange={this.handleChange('nome')} value={model.nome}/>

                            <TextField id="form-usuario-cpf" label="CPF" lineDirection="center" required
                                className="md-cell md-cell--bottom md-cell--12" placeholder="Digite o CPF do usuário" 
                                onChange={this.handleChangeCpf('cpf')} value={model.cpf}/>

                            <TextField id="form-usuario-email" label="Email" lineDirection="center" type="email" required
                                className="md-cell md-cell--bottom md-cell--12" placeholder="Digite o email do usuário" 
                                onChange={this.handleChange('email')} value={model.email}/>

                            <TextField id="form-usuario-senha" label="Senha" lineDirection="center" type="password"
                                className="md-cell md-cell--bottom md-cell--12" placeholder="Digite a senha do usuário" 
                                onChange={this.handleChange('senha')} value={model.senha}/>

                            <Switch id="form-usuario-ativo" label="Ativo" type="switch" name="form-usuario-ativo"
                                onChange={this.handleChange('ativo')} value={model.ativo} checked={model.ativo}/>
                        </div>
                    </section>
                </form>
            </DialogContainer>
        )
    }

    hide = () => {
        this.props.onHide();
    }

    handleSave = event => {
        event.preventDefault();
        let model = new Usuario(this.props.model);
        this.props.onSave(model);
    }

    handleChange = name => value => {
        let model = this.props.model;
        model[name] = value;
        this.props.onChange(model);
    }

    handleChangeCpf = name => value => {
        let model = this.props.model;
        model[name] = formatCpf(value);
        this.props.onChange(model);
    }
}

export default UsuarioForm;


// WEBPACK FOOTER //
// ./src/forms/UsuarioForm.js